import { useState, useEffect } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
// import { RolePermissionsSchema } from './RolePermissions.ValidationSchema';
import { toast } from 'react-toastify';
import { FormField } from '../../../../Components/FormField';
import SidebarField from '../../../../Components/SidebarField';
import TextInput from '../../../../Components/TextInput';
import SelectDropdown from '../../../../Components/Dropdown/SelectDropdown';
import Button from '../../../../Components/Button';
import MultiSelectDropDown from '../../../../Components/Dropdown/MultiSelectDropDown';
import { PermissionsSchema } from './Validationschema';
import ToggleField from '../../../../Components/ToggleField';
import { PermissionApi } from '../../../../App/api/role_and_permissions.api';

function AddPermissions({ currentItems, getAllData, open, handleClose }) {

  const initialValues = {
    name:currentItems?.name|| '',           
    isMandatory: currentItems?.isMandatory||false,  
    active:currentItems?.active|| false,       
    
  };
  
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("Data",values);
    
    try {
      // console.log('values', values);
      // Logic for creating or updating the role and permissions
      const response = currentItems?._id
        ? await PermissionApi.updatePermission(values, currentItems._id)
        : await PermissionApi.createPermission(values);

      getAllData();
      toast.success(currentItems?._id ? 'Permission updated' : 'Permission created');
    } catch (err) {
      console.error(err);
      toast.error(err?.message);
    } finally {
      resetForm();
      handleClose();
    }
  };



  if (open) {
    return (
      <div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
          validationSchema={PermissionsSchema}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={currentItems?._id ? 'Update Permissions' : 'Add New Permissions'}
                button1={<Button text="Cancel" type="button" onClick={handleClose} />}
                button2={<Button text={currentItems?._id ? 'Update' : 'Submit'} type="submit" />}
              >
                <FormField label="Permissions" tooltip="Enter Permissions name">                    
                     <TextInput
                      name="name"
                      type="text"
                      value={values.name}
                      placeholder="Permissions"
                      onChange={handleChange}
                      className="outline-none capitalize"
                    />
                  <ErrorMessage name="name" component="p" className="error" />
                </FormField>                
                 
               <div>
               <ToggleField
                  text={'Is Mandatory'}
                  name="isMandatory"
                  value={values.isMandatory}
                  toggaleHandleChange={(e)=>{
                    // console.log("v",e.target.value);
                    
                    setFieldValue('isMandatory',e.target.value)
                  }}
                />  
                <ErrorMessage name="isMandatory" component="p" className="error" />
               </div>
               
                <div>
                <ToggleField
                  text={values.active?"Enabled":'Disabled'}
                  name="active"
                  value={values.active}
                  toggaleHandleChange={(e)=>{
                    // console.log("v",e.target.value);
                    
                    setFieldValue('active',e.target.value)
                  }}
                />    
                 <ErrorMessage name="active" component="p" className="error" />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
  return null;
}

export default AddPermissions;
